import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  languageSupportSelector: {
    width: "25rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  languageSupportSettingContainer: {
    display: "inline-flex",
  },
  multiLanguageContainer: {
    display: "inline-flex",
    wdith: "100% "
  },
  multiLanguageSelector: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));